import { PageLoading } from "@/components/layout/Layout";

/**
 * Renders one of three states:
 *  - `loading`: spinner
 *  - `isEmpty`: empty placeholder (icon + title + hint)
 *  - else: the actual content (children)
 *
 * Avoids nested ternaries in pages.
 */
export function ListState({ loading, isEmpty, emptyIcon: Icon, emptyTitle, emptyHint, children }) {
    if (loading) {
        return <div className="p-6"><PageLoading /></div>;
    }
    if (isEmpty) {
        return (
            <div className="p-12 text-center">
                {Icon ? <Icon size={48} className="mx-auto text-muted-foreground mb-3" /> : null}
                <div className="font-display text-lg font-medium">{emptyTitle}</div>
                {emptyHint ? <div className="text-sm text-muted-foreground">{emptyHint}</div> : null}
            </div>
        );
    }
    return children;
}
